
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.456 27.456c4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97","stroke":"#424242","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"stroke":"#424242","stroke-width":"1.5","stroke-linecap":"round","d":"M19.75 7.328v2.5M10.061 11.578l1.767 1.768M7.75 19.828h2.5M27.75 19.828h2.5M27.768 11.578L26 13.346"}}),_c('circle',{attrs:{"cx":"19","cy":"19","r":"1","fill":"#424242"}})])
          )
        }
      }
    